import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawyerInfos } from '../../lawyer.types';
import { Hyperlink } from '../../../components/Hyperlink';
import { UserContext } from '../../../user/UserContext';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useModal } from '../../../components/modal/useModal';
import styles from './lawyer_notify_error.module.scss';
import { VerifyLawyerModal } from '../../verify-lawyer-modal/VerifyLawyerModal';

type Props = {
  lawyerInfos: LawyerInfos;
  lawyerIsCurrentUser: boolean;
  lawyerName: string;
};

export const LawyerNotifyError: FC<Props> = ({
  lawyerInfos,
  lawyerIsCurrentUser,
  lawyerName,
}) => {
  const { accessPremium, currentUser } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  const { openModal } = useModal(modalProps => (
    <VerifyLawyerModal
      lawyerId={lawyerInfos.lawyerId}
      lawyerName={lawyerName}
      {...modalProps}
    />
  ));

  const openVerifyLawyerModal = () => {
    if (!accessPremium) {
      return openRestrictedModal({ source: 'notify-error' });
    }
    doctrineAnalytics('Professional WantToBeVerified', {
      source: 'professional_top',
    });
    openModal();
  };

  if (
    !lawyerIsCurrentUser &&
    (lawyerInfos.lawyerIsVerified || currentUser.verified)
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Hyperlink
        className={styles.link}
        {...(lawyerIsCurrentUser && currentUser.verified
          ? {
              href: '/profil/signaler',
              source: 'lawyer_notify_issue',
            }
          : {
              onClick: openVerifyLawyerModal,
            })}
      >
        <em>
          <FormattedMessage id="app.pages.lawyer.modify" />
        </em>
      </Hyperlink>
    </div>
  );
};
